export default class Files {
	constructor(name, endpoint) {
		window[name] = this.data(endpoint)
	}

	data() {
		return {
			files: [],
			SubPlan: null,
			newFile: null,
			Type: null,
			CustomProperties: null,

			Init(Type, SubPlan, CustomProperties = []) {
				var vm = this;
				vm.SubPlan = SubPlan;
				vm.Type = Type;
				vm.CustomProperties = CustomProperties;
				if (this.$el.parentNode.hasAttribute('data-quesiton-uid')) {
					vm.CustomProperties = JSON.stringify({ 'quesitonUid': this.$el.parentNode.getAttribute('data-quesiton-uid') });
				}
				this.GetFiles(vm.Type, vm.CustomProperties);
			},



			UploadFile(Event, Type){
				var vm = this;
				var fileInput = Event.target;
				var xhttp = new XMLHttpRequest();
				var bodyFormData = new FormData();
				bodyFormData.append('file', fileInput.files[0]);
				bodyFormData.append('subplan', this.SubPlan);
				xhttp.open('post', '/woonmens/api/upload-files', true);

				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						var responce = JSON.parse(this.responseText)
						fileInput.value = ''
						vm.GetFiles(vm.Type, vm.CustomProperties);
					}
				}
				xhttp.send(bodyFormData);
			}, 

			GetFiles(Type, CustomProperties){
				var vm = this;
				var xhttp = new XMLHttpRequest();
				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						var response = JSON.parse(this.responseText)
						if (typeof response.Files !== 'undefined') {
							vm.files = response.Files;
							vm.initialised = true;
						}
						// vm.files = response.Files;
						// vm.initialised = true;
					}
				} 
				xhttp.open('post', '/woonmens/api/get-files/', true);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				setTimeout(function() {
					xhttp.send(JSON.stringify({
						'Type': Type,
						'CustomProperties': CustomProperties
					}));
				}, 500)
			},

			getSourceUrl(UniqueId){
				var vm = this;

				var File = vm.SearchForFile(UniqueId, vm.files);
				if(!File) return; 

				return "/woonmens/api/show-file/" +  encodeURIComponent(window.btoa(File.url)) 
			},

			DownloadFile(UniqueId){
				var vm = this;
				var File = vm.SearchForFile(UniqueId, vm.files);
				if(!File) return; 
				var url = '/woonmens/api/download-file/?u=' + vm.Encode(File.url) + "&t=" + vm.Encode(File.mime_type) + "&n=" + vm.Encode(File.name);
				
				return window.open(url, '_blank');


			},

			SearchForFile(UniqueId, Arr){
				if(!Arr) return null;
				for (var i=0; i < Arr.length; i++) {
					if (Arr[i].unique_id === UniqueId) {
						return Arr[i];
					}
				}
			},

			Encode(String){
				return encodeURIComponent(window.btoa(String))
			}
		}
	}
}